import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/hand_snap.svg'


const _withScopeId = n => (_pushScopeId("data-v-73402027"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modalContent" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_localized_text, {
          type: "h1",
          localizedKey: "app_Evvai!",
          text: "Evvai!"
        }),
        _createVNode(_component_localized_text, {
          type: "h1",
          localizedKey: "app_Ora si fa sul serio",
          text: "Ora si fa sul serio"
        }),
        _createVNode(_component_localized_text, {
          type: "p",
          localizedKey: "app_Abbiamo inviato la mail di conferma all’indirizzo",
          text: "Abbiamo inviato la mail di conferma all’indirizzo",
          class: "text mt-4 mb-0"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.email), 1)
      ])
    ])
  ]))
}